import { CircularProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import { invokeApi } from "../../../../../../bl_libs/invokeApi";
import { get_request_status } from "../../../../../../ui_libs/constants";
import {
  getMovers,
  time_convert,
} from "../../../../../../ui_libs/Functions/functions";
import StartMove from "./StartMove";

function ReadyToMove(props) {
  const { requestData, fetchRequestDetails } = props;
  const { truck_array, request, additional_status } = requestData;
  const {
    id,
    final_amount,
    start_window_from,
    start_window_to,
    s_time,
    request_type,
    request_timeline_status,
  } = requestData.request;
  const { first_name, last_name, user_model } =
    requestData.get_foreman_of_company;

  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [errMessage, setErrMessage] = React.useState("");
  const [warning, setWarning] = useState("");

  const startMove = () => {
    const {
      delete_address_array,
      edit_address_array,
      new_address_array,
      change_item_extra,
      change_item,
    } = requestData;
    if (
      delete_address_array.length > 0 ||
      new_address_array.length > 0 ||
      edit_address_array.length > 0 ||
      change_item.length > 0 ||
      change_item_extra.length > 0
    ) {
      setWarning("Please wait, Until company response customer's changes.");
      return;
    }
    setWarning("");

    let requestObj = {
      path: "/api/foreman/start_move",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${id}`,
    };

    requestObj["postData"] = postData;
    setIsLoadingBtn(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        fetchRequestDetails();
      } else {
        setErrMessage(res.message);
        setIsLoadingBtn(false);
      }
    });
  };

  return (
    <>
      <div className="rounded-box">
        <div className="heading-wrapper black-bg text-center">
          <h6 className="text-white">Request #{id}</h6>
        </div>
        {errMessage && (
          <Alert variant="filled" severity="error">
            {errMessage}
          </Alert>
        )}
        {warning && (
          <Alert variant="filled" severity="warning">
            {warning}
          </Alert>
        )}
        <div className="request-left-box p-3 p-sm-4">
          <div className="row">
            <div className="col-8">
              <div className="request-staus small-font-size">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                </svg>{" "}
                {get_request_status(
                  request_timeline_status,
                  request_type,
                  additional_status
                )}
              </div>
            </div>
            <div className="col-4 text-right">
              {request.sale_man_request_status && (
                <span className="custom-chip">Against You</span>
              )}
            </div>
          </div>
          <div className="bid-form-wrapper pt-3">
            <div className="row small-font-size">
              <div className="col-6 text-left dark-grey-color">Start time:</div>
              <div className="col-6 text-right black-color">
                {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
                {s_time &&
                  s_time !== "8AM - 12PM Morning" &&
                  s_time !== "12PM - 5PM Evening" &&
                  s_time !== "Entire day" &&
                  `${time_convert(
                    s_time.split("-")[0].trim()
                  )} to ${time_convert(s_time.split("-")[1].trim())}`}
                {s_time &&
                  (s_time == "8AM - 12PM Morning" ||
                    s_time == "12PM - 5PM Evening" ||
                    s_time == "Entire day") &&
                  `${s_time}`}
              </div>
            </div>

            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Movers:</div>
              <div className="col-6 text-right black-color">
                {getMovers(requestData)}
              </div>
            </div>

            {request_type && (
              <>
                {/* Hourly rate details */}
                {requestData.request.rate_method === "Hourly" && (
                  <>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Cash Hour Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.cash_payment_rate}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Card Hour Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.card_payment_rate}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Minimum Hours:
                      </div>
                      <div className="col-6 text-right black-color">
                        {requestData.request.minimum_hours}
                      </div>
                    </div>
                  </>
                )}
                {/* Flat rate details */}
                {requestData.request.rate_method === "Flat" && (
                  <>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Cash Flat Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.cash_min_flat_rate} - $
                        {requestData.request.cash_max_flat_rate}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Card Flat Rate:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${requestData.request.card_min_flat_rate} - $
                        {requestData.request.card_max_flat_rate}
                      </div>
                    </div>
                  </>
                )}
                {requestData.request.customer_phone_number && (
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Customer Phone #:
                    </div>
                    <div className="col-6 text-right black-color">
                      {requestData.request.customer_phone_number}
                    </div>
                  </div>
                )}
              </>
            )}
            {truck_array.length > 0 && (
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">
                  Truck Name:
                </div>
                <div className="col-6 text-right light-red-color">
                  {truck_array.map((truck, i) => {
                    return (
                      truck.name + (i === truck_array.length - 1 ? "" : ", ")
                    );
                  })}
                </div>
              </div>
            )}
            {first_name && (
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">
                  Foreman name:
                </div>
                <div className="col-6 text-right light-red-color">
                  {first_name + " " + last_name}
                </div>
              </div>
            )}
            {!request_type && (
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">Price:</div>
                <div className="col-6 text-right black-color">
                  ${final_amount}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <StartMove startMove={startMove} />
    </>
  );
}

export default ReadyToMove;
